export var white = '#ffffff';
export var yellow = '#FFB300';
export var blue = '#456292';
export var lightBlue = '#A2BAE4';
export var dark = '#242B33';
export var darkAlt = '#2D3640';
export var grey = '#485666';
export var darkLight = '#36414D';
export var hiveGrey = '#3E4C59';
export var darkGrey = '#333f48';
export var black = '#000000';
export var lightGrey = 'rgba(255, 255, 255, 0.5)';
export var mediumGrey = '#7e8a94';
export var solidLightGrey = '#f5f5f5';
export var solidGrey = '#D9D9D9';
export var solidDarkGrey = '#A6A6A6';
export var solidDarkerGrey = '#737373';